export default "__VITE_ASSET__CqY_Q4lM__"